import React, {useState} from 'react';
import {Button, Card, Icon, Table} from "react-materialize";
import styled from "styled-components";

import AuthRole from "./AuthRole.react";
import SettingsModal from "../SettingsModal.react";

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 80%;
  padding-right: 4rem;

  
  .header-title {
    color: white;
    font-size: 3rem;
    font-weight: 400;
    letter-spacing: 1px;
    padding-top: 1.5rem;
    padding-left: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    
    .create-button {
      text-align: right;
      padding-bottom: 1rem;
      
      .btn {
        color: #515151;
        background-color: white;
        border: 1px solid white;
     
        display: flex;
        
        i {
          font-size: 1.5rem;
          font-weight: bold;
          margin-left: .5rem;
        }
        
        :hover {
          color: #3388BD;
        }
      }
    }
  }
`

const StyledRoles = styled.div`
  .role-details {
    display: flex;
    flex-direction: column;
    padding-top: 1rem;
    
    ::before {
      content: "";
      position: absolute;
      width: 93%;
      height: 2px;
      background-color: white;
    }
    //
    //::after {
    //  content: "";
    //  position: absolute;
    //  width: 136rem;
    //  height: 2px;
    //  background-color: white;
    //}
  }
  
  thead {
    background: white;
    color: #262626;
    border-bottom: 1px solid #EFEFEF;
  }
  
  th, td {
    padding: 1.5rem;
  }
  
  table {
    background: white;
    border: 1px solid white;
  }
`

const AuthRoles = ({roles, loading}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    console.log('add role')
    setOpen(true);
  }

  const handleModalClose = () => {
    setOpen(false);
  }

  return (
    <StyledCard>
      <SettingsModal open={open} handleClose={handleModalClose} primaryLabel={'Role'} />
        <div className={'header-title'}>
          <h2>Role Management</h2>
          <div className={'create-button'}>
            <Button onClick={handleClick}>
              Create Role
              <Icon>enhanced_encryption</Icon>
            </Button>
          </div>
        </div>
        <StyledRoles>
          <div className={'role-details'}>
            <div>
              <Table>
                <thead>
                <tr>
                  <th data-field="role">
                    Role
                  </th>
                  <th data-field="description">
                    Description
                  </th>
                  <th data-field="id">
                    Id
                  </th>
                  <th data-field={'actions'}>
                    Actions
                  </th>
                </tr>
                </thead>
                <tbody>
                  {
                    roles?.map((role) => {
                      return <AuthRole role={role} />
                    })
                  }
                </tbody>
              </Table>
            </div>
          </div>
        </StyledRoles>
    </StyledCard>
  )
}

export default AuthRoles;